/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_Gk_71_107(e) {
  let t = (0, ReactCompiler.c)(5),
    { numero: n } = e;
  if (!n) {
    let e;
    return (
      t[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <span
              className={`rounded-full bg-(--warning-bg) px-2 py-0.5 text-[11px] text-(--warning-texto)`}
              children={`Sin celular`}
            />
          )),
          (t[0] = e))
        : (e = t[0]),
      e
    );
  }
  let r = String(n),
    i;
  t[1] === r
    ? (i = t[2])
    : ((i = /^51\d{9}$/.test(r)
        ? `+51 ${r.slice(2, 5)} ${r.slice(5, 8)} ${r.slice(8)}`
        : `+${r}`),
      (t[1] = r),
      (t[2] = i));
  let a = i,
    o;
  return (
    t[3] === a
      ? (o = t[4])
      : ((o = (
          <span className={`whitespace-nowrap text-(--text)`} children={a} />
        )),
        (t[3] = a),
        (t[4] = o)),
    o
  );
}
